import React, { useState, useRef, useEffect } from 'react';



const QuickActionBar = () => {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [isAutoRefresh, setIsAutoRefresh] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState('Last 7 days');
  const datePickerRef = useRef(null);

  const dateRangeOptions = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'Last 7 days', value: 'last-7-days' },
  { label: 'Last 30 days', value: 'last-30-days' },
  { label: 'This month', value: 'this-month' },
  { label: 'Last month', value: 'last-month' },
  { label: 'Custom range', value: 'custom' }];


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (datePickerRef?.current && !datePickerRef?.current?.contains(event?.target)) {
        setIsDatePickerOpen(false);
      }
    };

    if (isDatePickerOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDatePickerOpen]);

  const handleDateRangeSelect = (option) => {
    setSelectedDateRange(option?.label);
    setIsDatePickerOpen(false);
  };

  const handleRefreshToggle = () => {
    setIsAutoRefresh(!isAutoRefresh);
  };

  const handleManualRefresh = () => {
    console.log('Manual refresh triggered');
  };

  const handleExport = () => {
    console.log('Export data triggered');
  };

  return (
    <div className="quick-action-bar">
      <div className="relative hidden md:block" ref={datePickerRef}>
        












        {isDatePickerOpen &&
        <div className="absolute right-0 mt-2 w-56 bg-popover border border-border rounded-lg shadow-lg z-[300]">
            <div className="p-2">
              {dateRangeOptions?.map((option) =>
            <button
              key={option?.value}
              onClick={() => handleDateRangeSelect(option)}
              className="w-full text-left px-3 py-2 rounded-md text-sm text-popover-foreground hover:bg-muted transition-base">

                  {option?.label}
                </button>
            )}
            </div>
          </div>
        }
      </div>
      







      







      







    </div>);

};

export default QuickActionBar;